import { LAB_REPORT } from "@/api_framework/api_config";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";

export const useDeleteTRFReasonsAPI = () => {
  const configuration = useConfiguration();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();
  const [deleteTRFReasons, setDeleteTRFReasons] = useState<string[]>([]);

  const execute = useCallback(async () => {
    try {
      const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
      await axios
        .get(LAB_REPORT?.LAB_REPORT_TRF_DELETE_REASONS?.baseURL, {
          headers: {
            Authorization: `${accessToken}`,
            "Content-Type": "application/json",
          },
        })
        .then((res: AxiosResponse<any>) => {
          const reasons = res?.data?.status === true && Array.isArray(res?.data?.data) ? res.data.data : [];
          setDeleteTRFReasons(reasons);
        })
        .catch((e: AxiosError) => {
          setDeleteTRFReasons([]);
          e.config && sendCurl(e.config["curlCommand"]);
          captureError(e);
        });
    } catch (e: any) {
      setDeleteTRFReasons([]);
      toast.error("Server Error: " + e.message);
    }
  }, [configuration, sendCurl, captureError]);

  return { execute, deleteTRFReasons };
};
